import { PilotId } from '~/eds/src/types/PilotId';
import { SearchQuery } from '~/features/advanced-search/types';
import { PilotSearchQuery } from '~/redux/api/methods/search';
import {
  BooleanQueryEntity,
  EntityQuery,
  FilterQueryEntity,
  QueryOperatorEntity,
  SectionEntity,
} from '~/types/OpenSearch';

import { SavedSearch } from '../types/search';

export const testIsFilter = (
  queryEntity: EntityQuery,
): queryEntity is FilterQueryEntity => queryEntity.type === 'filter';

export const testIsSection = (
  queryEntity: EntityQuery,
): queryEntity is SectionEntity => queryEntity.type === 'section';

export const testIsBooleanTextSearch = (
  queryEntity: EntityQuery,
): queryEntity is BooleanQueryEntity => queryEntity.type === 'bool_text_search';

export const testIsOperator = (
  queryEntity: EntityQuery,
): queryEntity is QueryOperatorEntity => queryEntity.type === 'operator';

export const testIsQueryV2 = (
  savedSearch: SavedSearch,
): savedSearch is SavedSearch & { query: PilotSearchQuery } => {
  return savedSearch.version === 2;
};

export const testIsQueryV3 = (
  savedSearch: SavedSearch,
): savedSearch is SavedSearch & { query: SearchQuery } => {
  return savedSearch.version === 3;
};

export const testHasNestedSections = (query: SearchQuery) => {
  const firstLevelSections = query.filter(testIsSection);
  return firstLevelSections.some((section) =>
    section.value.some(testIsSection),
  );
};

export const testHasOrOperator = (query: SearchQuery) =>
  query.filter(testIsOperator).some((operator) => operator.value === 'or');

export const testHasMixedOperatorInSection = (query: SearchQuery) =>
  query
    .filter(testIsSection)
    .some((section) => testHasMixedOperators(section.value));

export const testHasMixedOperators = (query: SearchQuery) =>
  query
    .filter(testIsOperator)
    .some((operator, _, arr) =>
      operator.value === 'and' || operator.value === 'or'
        ? arr.some((op) => op.value !== operator.value)
        : false,
    );

export const getActiveFilterIds = (query: SearchQuery): PilotId[] => {
  return query.filter(testIsFilter).map((filter) => filter.id);
};
